/*
* Created on Jan 21, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React from 'react';
import TableToolbarComponent from "./TableToolbarComponent";
import TableToolbarSearchResultComponent from "./TableToolbarSearchResultComponent";
import TableContentComponent from "./TableContentComponent";
import OrgContentPlaceholderComponent from "../../organization-content/OrgContentPlaceholderComponent";
import TableContentPagination from "./TableContentPagination";
import {useTranslation} from "react-i18next";

const TableComponent = ({name, table_icon, row_component, table_head_fields, table_data, total_record, doRefresh, disPatcher, table_ui, search=true, isOwner=true, createText=null, permissions=null, empty_data=null, data_table_name="", css_with_context_wrapper=true, pagination=true, table_height='100%', state=null}) => {
    const {t} = useTranslation();
    return (
        <>
            {!table_data.data && <OrgContentPlaceholderComponent />}
            {table_data.data &&
                <>
                    { (name || table_icon) &&
                        <div className="content-title">
                            <div className="title-ic"><img src={table_icon} alt=""/></div>
                            <div className="title-label">{t(`@${name}@`)}</div>
                        </div>
                    }
                    {table_ui?.toolbar && <TableToolbarComponent name={name} table_data={table_data} total_record={total_record} disPatcher={disPatcher} table_ui={table_ui} search={search} isOwner={isOwner} createText={createText} permissions={permissions}/>}
                    {/*<TableToolbarSearchResultComponent />*/}
                    <TableContentComponent translate={t} table_head_fields={table_head_fields} table_data={table_data} row_component={row_component} doRefresh={doRefresh} disPatcher={disPatcher} table_ui={table_ui} search={search} isOwner={isOwner} permissions={permissions} empty_data={empty_data} data_table_name={data_table_name} css_with_context_wrapper={css_with_context_wrapper} table_height={table_height} state={state}/>
                    {pagination && <TableContentPagination total_content={total_record} table_data={table_data.data} disPatcher={disPatcher}/>}
                </>
            }
        </>
    );
};

export default TableComponent;